module.exports = __webpack_public_path__ + "img/RW.542d6d5b.png";